import React, { useEffect, useState } from 'react';
import { apiClient } from '../../services/apiClient';

/**
 * Persistent banner shown when the backend is bound to the DEVELOPMENT
 * environment (dev ODS / dev MEJAMES). Renders nothing in production.
 *
 * Source of truth is the backend's /api/environment endpoint, which reflects
 * which databases this instance is actually pointed at — so the banner can't
 * be fooled by hostname/routing.
 */
export const EnvBanner: React.FC = () => {
  const [info, setInfo] = useState<{ db_env: string; is_dev: boolean } | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get('/api/environment')
      .then((res) => { if (!cancelled) setInfo(res.data); })
      .catch(() => { /* on failure, show nothing (fail safe = no false DEV label) */ });
    return () => { cancelled = true; };
  }, []);

  if (!info || !info.is_dev) return null;

  return (
    <div
      className="w-full bg-red-600 text-white text-center text-xs font-semibold tracking-wide py-1 shadow-sm z-50"
      title="This instance is connected to the DEV Catalytic ODS / MEJAMES databases"
    >
      DEV ENVIRONMENT — connected to development databases (not production)
    </div>
  );
};
